/**
 * dir-w | backOffice
 * Show data table
 *
 * Last update : Angular 18, 2024 | @rizkiprasetya
 */

import { Component } from '@angular/core';

@Component({
    selector: 'app-data-table',
    templateUrl: './data-table.component.html',
    styleUrl: './data-table.component.css',
    standalone: false
})
export class DataTableComponent {
  protected isLoading: boolean = true;
}
